<app-menu-superior [user]="user" [button]="true" [title]="'CONTRASEÑA'"></app-menu-superior>

<ion-content class="ion-align-items-center ion-justify-content-center bg-content full-height">
  <ion-grid>
    <ion-row class="flex-row-center">
      <ion-col size="1"></ion-col>
      <ion-col size="10" class="tarjet">
        <ion-row>
          <ion-col></ion-col>
          <ion-col size="10" class="vertical">
            <form (ngSubmit)="onSubmit()">
              <ion-col class="vertical">
                <div class="headerText vertical"><b>Cambiar contraseña</b></div>
              </ion-col>
              <ion-img class="headerImg mgTop" src="assets/logos/logo_1.png"></ion-img>
              <p class="mgTop">Hola {{user.username}}, recuerda que una contraseña segura contribuye a evitar accesos no
                autorizados a tu cuenta.</p>
              <ion-label position="floating">Contraseña actual</ion-label>
              <ion-input label="" type="password" name="actualPassword" class="inputContrasenha"
                [(ngModel)]="actualPassword" required></ion-input>

              <ion-label position="floating">Nueva contraseña</ion-label>
              <ion-input label="" type="password" class="inputContrasenha" name="newPassword"
                [(ngModel)]="newPassword"></ion-input>
              <div *ngIf="newPassword">
                <ion-progress-bar [value]="passwordStrength(newPassword) / 4"
                  [color]="getPasswordStrengthColor(newPassword)"></ion-progress-bar>
              </div>

              <ion-label position="floating">Repita nueva contraseña</ion-label>
              <ion-input label="" type="password" class="inputContrasenha" name="newPasswordAgain"
                [(ngModel)]="newPasswordAgain" required></ion-input>
              <div *ngIf="newPasswordAgain">
                <ion-progress-bar [value]="passwordStrength(newPasswordAgain) / 4"
                  [color]="getPasswordStrengthColor(newPasswordAgain)"></ion-progress-bar>
              </div>
              <div padding class="ion-text-center mgTop">
                <ion-label class="mensajeError">{{error}}</ion-label>
              </div>
              <div padding class="ion-text-center mgTop">
                <ion-label class="mensajeCorrecto">{{correcto}}</ion-label>
              </div>
              <ion-button class="mgTop" size="large" (click)="onSubmit()" expand="block"
                fill="solid">Continuar</ion-button>
            </form>
          </ion-col>
          <ion-col></ion-col>
        </ion-row>
      </ion-col>
      <ion-col size="1"></ion-col>
    </ion-row>
  </ion-grid>
</ion-content>